/* eslint-disable no-undef */
import { Controller } from 'stimulus';

export default class AdsController extends Controller {
  connect() {
    this.TMSAdsLoaded = false;

    window.addEventListener('load', this.initAds);
    window.addEventListener('turbolinks:load', this.initAds);
    window.addEventListener('turbolinks:before-visit', this.resetAds);
  }

  disconnect() {
    window.removeEventListener('load', this.initAds);
    window.removeEventListener('turbolinks:load', this.initAds);
    window.removeEventListener('turbolinks:before-visit', this.resetAds);
  }

  initAds = () => {
    const tmsAdScriptCheck = setInterval(() => {
      if (this.tmsAdsReady && !this.TMSAdsLoaded) {
        window.TMSAds.setLayout(document.body.dataset.adLayout);

        this.TMSAdsLoaded = true;
      }

      if (this.tmsAdsReady) {
        clearInterval(tmsAdScriptCheck);
      }
    }, 100);
  }

  get tmsAdsReady() {
    if (typeof window.TMSAds === 'undefined') return false;
    if (typeof window.TMSAds.setLayout === 'undefined') return false;

    return true;
  }

  resetAds = () => {
    this.disconnect();

    this.connect();
  }
}
/* eslint-enable no-undef */
